/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { CategoryResponse } from '../models/category-response';
import { deleteApiCategoryV1Id } from '../fn/category/delete-api-category-v-1-id';
import { DeleteApiCategoryV1Id$Params } from '../fn/category/delete-api-category-v-1-id';
import { getApiCategoryV1Id$Json } from '../fn/category/get-api-category-v-1-id-json';
import { GetApiCategoryV1Id$Json$Params } from '../fn/category/get-api-category-v-1-id-json';
import { getApiCategoryV1Id$Plain } from '../fn/category/get-api-category-v-1-id-plain';
import { GetApiCategoryV1Id$Plain$Params } from '../fn/category/get-api-category-v-1-id-plain';
import { GetCategoryResponse } from '../models/get-category-response';
import { postApiCategoryV1$Json } from '../fn/category/post-api-category-v-1-json';
import { PostApiCategoryV1$Json$Params } from '../fn/category/post-api-category-v-1-json';
import { postApiCategoryV1$Plain } from '../fn/category/post-api-category-v-1-plain';
import { PostApiCategoryV1$Plain$Params } from '../fn/category/post-api-category-v-1-plain';
import { postApiCategoryV1Create$Json } from '../fn/category/post-api-category-v-1-create-json';
import { PostApiCategoryV1Create$Json$Params } from '../fn/category/post-api-category-v-1-create-json';
import { postApiCategoryV1Create$Plain } from '../fn/category/post-api-category-v-1-create-plain';
import { PostApiCategoryV1Create$Plain$Params } from '../fn/category/post-api-category-v-1-create-plain';
import { putApiCategoryV1Id$Json } from '../fn/category/put-api-category-v-1-id-json';
import { PutApiCategoryV1Id$Json$Params } from '../fn/category/put-api-category-v-1-id-json';
import { putApiCategoryV1Id$Plain } from '../fn/category/put-api-category-v-1-id-plain';
import { PutApiCategoryV1Id$Plain$Params } from '../fn/category/put-api-category-v-1-id-plain';

@Injectable({ providedIn: 'root' })
export class CategoryService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `postApiCategoryV1()` */
  static readonly PostApiCategoryV1Path = '/private/v1/categories';

  /**
   * Retrive the list all the existing categories from the database asynchronously.
   *
   * Retrive the list all the existing categories from the database asynchronously
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postApiCategoryV1$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postApiCategoryV1$Plain$Response(params?: PostApiCategoryV1$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<GetCategoryResponse>> {
    return postApiCategoryV1$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Retrive the list all the existing categories from the database asynchronously.
   *
   * Retrive the list all the existing categories from the database asynchronously
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postApiCategoryV1$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postApiCategoryV1$Plain(params?: PostApiCategoryV1$Plain$Params, context?: HttpContext): Observable<GetCategoryResponse> {
    return this.postApiCategoryV1$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetCategoryResponse>): GetCategoryResponse => r.body)
    );
  }

  /**
   * Retrive the list all the existing categories from the database asynchronously.
   *
   * Retrive the list all the existing categories from the database asynchronously
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postApiCategoryV1$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postApiCategoryV1$Json$Response(params?: PostApiCategoryV1$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<GetCategoryResponse>> {
    return postApiCategoryV1$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Retrive the list all the existing categories from the database asynchronously.
   *
   * Retrive the list all the existing categories from the database asynchronously
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postApiCategoryV1$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postApiCategoryV1$Json(params?: PostApiCategoryV1$Json$Params, context?: HttpContext): Observable<GetCategoryResponse> {
    return this.postApiCategoryV1$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetCategoryResponse>): GetCategoryResponse => r.body)
    );
  }

  /** Path part for operation `getApiCategoryV1Id()` */
  static readonly GetApiCategoryV1IdPath = '/private/v1/categories/{id}';

  /**
   * Retrieves a Category by ID.
   *
   * Retrieves a Category by ID.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getApiCategoryV1Id$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  getApiCategoryV1Id$Plain$Response(params: GetApiCategoryV1Id$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<CategoryResponse>> {
    return getApiCategoryV1Id$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Retrieves a Category by ID.
   *
   * Retrieves a Category by ID.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getApiCategoryV1Id$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getApiCategoryV1Id$Plain(params: GetApiCategoryV1Id$Plain$Params, context?: HttpContext): Observable<CategoryResponse> {
    return this.getApiCategoryV1Id$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<CategoryResponse>): CategoryResponse => r.body)
    );
  }

  /**
   * Retrieves a Category by ID.
   *
   * Retrieves a Category by ID.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getApiCategoryV1Id$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  getApiCategoryV1Id$Json$Response(params: GetApiCategoryV1Id$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<CategoryResponse>> {
    return getApiCategoryV1Id$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Retrieves a Category by ID.
   *
   * Retrieves a Category by ID.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getApiCategoryV1Id$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getApiCategoryV1Id$Json(params: GetApiCategoryV1Id$Json$Params, context?: HttpContext): Observable<CategoryResponse> {
    return this.getApiCategoryV1Id$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<CategoryResponse>): CategoryResponse => r.body)
    );
  }

  /** Path part for operation `putApiCategoryV1Id()` */
  static readonly PutApiCategoryV1IdPath = '/private/v1/categories/{id}';

  /**
   * Updates an existing Category details by ID.
   *
   * Updates an existing Category details by ID.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `putApiCategoryV1Id$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  putApiCategoryV1Id$Plain$Response(params: PutApiCategoryV1Id$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<CategoryResponse>> {
    return putApiCategoryV1Id$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Updates an existing Category details by ID.
   *
   * Updates an existing Category details by ID.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `putApiCategoryV1Id$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  putApiCategoryV1Id$Plain(params: PutApiCategoryV1Id$Plain$Params, context?: HttpContext): Observable<CategoryResponse> {
    return this.putApiCategoryV1Id$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<CategoryResponse>): CategoryResponse => r.body)
    );
  }

  /**
   * Updates an existing Category details by ID.
   *
   * Updates an existing Category details by ID.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `putApiCategoryV1Id$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  putApiCategoryV1Id$Json$Response(params: PutApiCategoryV1Id$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<CategoryResponse>> {
    return putApiCategoryV1Id$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Updates an existing Category details by ID.
   *
   * Updates an existing Category details by ID.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `putApiCategoryV1Id$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  putApiCategoryV1Id$Json(params: PutApiCategoryV1Id$Json$Params, context?: HttpContext): Observable<CategoryResponse> {
    return this.putApiCategoryV1Id$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<CategoryResponse>): CategoryResponse => r.body)
    );
  }

  /** Path part for operation `deleteApiCategoryV1Id()` */
  static readonly DeleteApiCategoryV1IdPath = '/private/v1/categories/{id}';

  /**
   * Delete an Category Details by ID.
   *
   * Delete an Category Details by ID.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteApiCategoryV1Id()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteApiCategoryV1Id$Response(params: DeleteApiCategoryV1Id$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return deleteApiCategoryV1Id(this.http, this.rootUrl, params, context);
  }

  /**
   * Delete an Category Details by ID.
   *
   * Delete an Category Details by ID.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteApiCategoryV1Id$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteApiCategoryV1Id(params: DeleteApiCategoryV1Id$Params, context?: HttpContext): Observable<void> {
    return this.deleteApiCategoryV1Id$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `postApiCategoryV1Create()` */
  static readonly PostApiCategoryV1CreatePath = '/private/v1/categories/Create';

  /**
   * Creates a new Category.
   *
   * Creates a new Category.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postApiCategoryV1Create$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postApiCategoryV1Create$Plain$Response(params?: PostApiCategoryV1Create$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<CategoryResponse>> {
    return postApiCategoryV1Create$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Creates a new Category.
   *
   * Creates a new Category.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postApiCategoryV1Create$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postApiCategoryV1Create$Plain(params?: PostApiCategoryV1Create$Plain$Params, context?: HttpContext): Observable<CategoryResponse> {
    return this.postApiCategoryV1Create$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<CategoryResponse>): CategoryResponse => r.body)
    );
  }

  /**
   * Creates a new Category.
   *
   * Creates a new Category.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postApiCategoryV1Create$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postApiCategoryV1Create$Json$Response(params?: PostApiCategoryV1Create$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<CategoryResponse>> {
    return postApiCategoryV1Create$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Creates a new Category.
   *
   * Creates a new Category.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postApiCategoryV1Create$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postApiCategoryV1Create$Json(params?: PostApiCategoryV1Create$Json$Params, context?: HttpContext): Observable<CategoryResponse> {
    return this.postApiCategoryV1Create$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<CategoryResponse>): CategoryResponse => r.body)
    );
  }

}
